import { isElectron } from '../../helpers/EnvironmentFlags/EnvironmentFlags';
import { HomeKiosk } from './HomeKiosk';
import { HomeWeb } from './HomeWeb';

export const Home = () => {
    const HomeComponent = isElectron() ? HomeKiosk : HomeWeb;

    return <HomeComponent />;
};
